import { Component, Input } from '@angular/core';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'reload-na-value',
    templateUrl: './reload-na-value.component.html',
    styleUrls: ['./reload-na-value.component.scss']
})
export class ReloadNAValueComponent {
    constructor() { }

    @Input()
    public value: any;

    @Input()
    public naValue: any;

    @Input()
    public clickHandler: any

    @Input()
    public alwaysReload: boolean;

    public isWaiting: boolean = false;

    private get isNA() {
        return this.value === this.naValue
    }

    public get canReload() {
        return this.isNA || this.alwaysReload;
    }

    public get valueToShow() {
        return this.isNA
            ? 'N/A'
            : this.value;
    }

    naClick(event: Event) {
        event.stopPropagation();
        if (!this.canReload || !this.clickHandler || this.isWaiting) {
            return;
        }
        this.isWaiting = true;
        this.clickHandler().subscribe(
            () => {
                this.isWaiting = false;
            },
            () => {
                this.isWaiting = false;
            });
    }
}
